import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setCurrentSemanticMapId } from "Slices/appState";
import { resetMissionsQueue } from "Slices/missionPlanner";
import { saveSemanticMapIdToStorage } from "./utils";

/**
 * Hook to handle semantic map selection
 * @returns A callback function to handle semantic map selection
 */
export const useSemanticMapSelection = () => {
  const dispatch = useDispatch();

  const handleSelectedSemanticMap = useCallback(
    (semanticMapId: string | null) => {
      dispatch(resetMissionsQueue());
      saveSemanticMapIdToStorage(semanticMapId);
      dispatch(setCurrentSemanticMapId(semanticMapId));
    },
    [dispatch]
  );

  return handleSelectedSemanticMap;
};
